/**
 * Hotels API — endpoint path builders.
 */

const API_BASE = process.env.RAZZLE_API_HOTEL_BOOKING?.replace(/\/$/, '') ?? '';
const VERSIONED_API_BASE = `${API_BASE}/api/v1`;
const BASE = `${VERSIONED_API_BASE}/hotels`;

// ── Real API: POST search stream (bodyless URL) ──

export function hotelSearchStreamUrl(): string {
  return `${BASE}/search/stream`;
}

// ── Real API: destination typeahead ──

export function destinationsUrl(search: string, limit: number): string {
  const clamped = Math.max(1, Math.min(25, Math.trunc(limit) || 1));
  return `${VERSIONED_API_BASE}/destinations?search=${encodeURIComponent(search)}&limit=${clamped}`;
}

// ── Masters, availability, detail ──

export function availabilityUrl(): string {
  return `${BASE}/availability`;
}

export function hotelByCodeUrl(code: string): string {
  return `${BASE}/${encodeURIComponent(code)}`;
}

export function countriesUrl(): string {
  return `${BASE}/masters/countries`;
}

export function destinationsByCountryUrl(countryCode: string): string {
  return `${BASE}/masters/countries/${encodeURIComponent(countryCode)}/destinations`;
}

export function mealsUrl(): string {
  return `${BASE}/masters/meals`;
}

export function typesUrl(): string {
  return `${BASE}/masters/types`;
}

export function suppliersUrl(): string {
  return `${BASE}/masters/suppliers`;
}

export function bookingsUrl(): string {
  return `${VERSIONED_API_BASE}/bookings`;
}

const MB_API_BASE = process.env.RAZZLE_API_MARCA_BLANCA?.replace(/\/$/, '') ?? '';

export function hotelInquiryUrl(): string {
  return `${MB_API_BASE}/consultas/hotel`;
}
